import { render, staticRenderFns } from "./SponsorList.vue?vue&type=template&id=1e398392&"
import script from "./SponsorList.vue?vue&type=script&lang=js&"
export * from "./SponsorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports